import Header from "@/components/Header";
import { useParams } from "react-router-dom";

const FeatureDetail = () => {
  const { featureId } = useParams();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-foreground mb-4">Feature Detail</h1>
        <p className="text-muted-foreground">Feature ID: {featureId}</p>
        <div className="mt-8">
          <p className="text-muted-foreground">Feature details coming soon...</p>
        </div>
      </main>
    </div>
  );
};

export default FeatureDetail;